<template>
  <div class="p-4">
    <l-container>
      <l-container-title
        slot="toolbar"
        text="User management"
        icon="user"
        color="bg-pastel-green-500"
      />
      <div v-show="true" class="w-full flex flex-col">
        <div class="flex mt-2 mb-2">
          <div class="mr-2">
            <l-input placeholder="Username" v-model="adduser_username" class="text-xs w-16"></l-input>
          </div>
          <div class="mr-2">
            <l-input placeholder="Password" v-model="adduser_pwd" class="text-xs w-16"></l-input>
          </div>
          <div class="mr-2">
            <l-button
              type="success"
              size="md"
              @click="onAddUserSave"
              :disabled="isAddUserDisabled"
            >Add user</l-button>
          </div>
        </div>
      </div>
    </l-container>
    <div class="w-full flex flex-col">
      <div class="flex align-baseline"></div>
    </div>
    <div class="w-full flex flex-col">
      <l-info-box class="mt-2 mb-2" :active="true">Select row and right click to open context menu</l-info-box>
      <hot-table :data="users" :settings="settings" ref="hot">
        <hot-column title="Username" data="username" read-only="true"></hot-column>
        <hot-column title="Created" data="created" read-only="true"></hot-column>
        <hot-column title="Created by" data="createdby" read-only="true"></hot-column>
      </hot-table>
    </div>

    <l-l-edit :showing="edit" @save="onChangePwd" @close="edit = false" :user="selectedUser" />
  </div>
</template>

<script>
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import UsermanagerService from "./usermanager.service";
import { LButton } from "@/components/forms";
import { LInput } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";
import ContextMenu from "./context.menu";
import LLEdit from "./LLEdit";

export default {
  name: "Usermanager",
  components: {
    HotTable,
    HotColumn,
    LButton,
    LInput,
    LInfoBox,
    LLEdit
  },
  data() {
    return {
      users: [],
      settings: HandsontableHelper.settings(false),
      adduser_username: "",
      adduser_pwd: "",
      manualSelection: false,
      selectedUser: {},
      edit: false
    };
  },
  computed: {
    isAddUserDisabled() {
      return this.adduser_username === "" || this.adduser_pwd === "";
    }
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData("Loading users", this.loadUsers);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    delUser(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while deleting the user",
            async () => {
              const rowsAffected = await UsermanagerService.deleteUser(
                row.username
              );
              const activeEditor = hot.getActiveEditor();
              hot.alter("remove_row", clickedRow, 1);
            }
          );
          Notify.success("User deleted!");
        }
      }, "This will delete the user. <br/><br/>Do you want to continue?");
    },
    changePassword(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selectedUser = row;
      this.edit = true;
    },
    async loadUsers() {
      this.users = await UsermanagerService.getusers();
    },
    async addUserSave() {
      await UsermanagerService.addUser(this.adduser_username, this.adduser_pwd);
      this.adduser_username = "";
      this.adduser_pwd = "";
      await this.loadUsers();
    },
    async onAddUserSave() {
      Notify.loadData("Adding user", this.addUserSave);
    },
    onCancelAddUser() {
      this.adduser_username = "";
      this.adduser_pwd = "";
    },
    async changePwd(o) {
      await UsermanagerService.changePwd(o.username, o.password);
    },
    async onChangePwd(o) {
      Notify.loadData("Changing password", this.changePwd, o);
    }
  }
};
</script>

<style lang="postcss">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.2/css/all.min.css";
</style>

